import request from "superagent";
import { instanceUrl, site } from "../utils/cms";
import { useEffect, useState } from "react";
var defaultPage404 = {
  title: "Siden ble ikke funnet",
  content: '<h3>Siden ble ikke funnet</h3><p>Vennligst kontroller adressen eller <a href="/">gå til hjemmesiden</a>.</p>',
  menu: "[]",
  is404: true
};

/**
 * Loads the given CMS page.
 *
 * @param {string} uri CMS uri to load.
 * @param {Object} page404 Page to use as 404 or error page.
 */
export default function usePage(uri, page404) {
  if (page404 === void 0) {
    page404 = defaultPage404;
  }
  var _useState = useState(null),
    page = _useState[0],
    setPage = _useState[1];
  useEffect(function () {
    setPage(null);
    if (!uri) return;
    request.post(instanceUrl() + "WebServices/cms/Page.asmx/GetPage").send({
      site: site(),
      uri: uri
    }).set("Accept", "application/json").end(function (err, response) {
      if (err || !response.ok) {
        setPage(page404);
        return;
      }
      var res = response.body.d.records[0];
      if (!res) {
        res = page404;
      }
      setPage({
        title: res.title,
        content: res.content,
        menu: res.menu && JSON.parse(res.menu) || [],
        data: res.data && JSON.parse(res.data) || {},
        is404: res.is404 || false
      });
    });
  }, [uri, page404]);
  return page;
}